'use strict';

window.console || (window.console = {
	log: function log() {}
});
var FUNCTIONS = window.FUNCTIONS || null;
var cssua = window.cssua || null;

(function ($) {
	var htmlHasClass = function htmlHasClass(_class) {
		return $('html').hasClass(_class);
	};
	var siteName = '';
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-fixed';
	var slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test\\.' + siteName + '\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.0\\.|192\\.168\\.11\\.|192\\.168\\.1\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var i, j;
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					for (i = 0; i < args.length; i++) {
						var result = args[i];
						var position = $(result[0]).filter(':first').attr('class').split(' ');

						for (j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(result[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle: function nextToggle() {
			var $switch = $('.js-toggle');

			$switch.on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll: function easeScroll() {
			$('a[rel="scroll"]').on('click', function (event) {
				var speed = 1200;
				if (/#/.test(event.currentTarget.href)) {
					scrollToObject(event.currentTarget.href, speed);
				}
				return false;
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos -= 60;
					} else {
						pos -= 90;
					}
				}

				$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
			}
		},
		easeScrollHash: function easeScrollHash() {
			var hash = location.hash;
			if (hash) {
				$(window).on('load', function () {
					// $('html, body').css('display', 'none');

					setTimeout(function () {
						// $('html, body').css('display', 'block');

						var _hash = '#' + hash.split('#')[1];
						var pos = $(_hash).offset().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= 60;
						} else {
							pos -= 90;
						}
						// $('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
						$('html, body').scrollTop(pos);
					}, 100);
				});
			}
		},
		pageTop: function pageTop() {
			var $pagetop = $('.footer-pagetop');

			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var $footer = $('.footer');
				// var footerPos = $footer.offset().top + $footer.height();
				var thisScroll = $this.scrollTop();
				// var pagetopPos = $this.height() + $footer.height() + thisScroll;

				if (thisScroll > '150') {
					$pagetop.addClass(v);
				} else {
					$pagetop.removeClass(v);
				}
			});
		},
		modal: function modal() {
			$('.mod-modal').on('click', function (e) {
				var HTML = '<div class="mod-modal-overlay">';
				HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><span></span></span>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
				$('body').append(HTML);
				var $overlay = $('.mod-modal-overlay');
				$overlay.addClass(a);
				setTimeout(function () {
					$overlay.addClass(v);
					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
			$('.mod-modal-text').on('click', function (e) {
				// console.log($(e.currentTarget).next('.di_none').find('.mod-modal-text-content').prop('outerHTML'));
				var HTML = '<div class="mod-modal-overlay">';
				HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><span></span></span>' + ($(e.currentTarget).next('.di_none').find('.mod-modal-text-content').prop('outerHTML') + '</div>');
				$('body').append(HTML);
				var $overlay = $('.mod-modal-overlay');
				$overlay.addClass(a);
				setTimeout(function () {
					$overlay.addClass(v);
					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		headerMenu: function headerMenu() {
			var $menu = $('.js-header-menu');
			var $menucontent = $('.js-header-menu-content');
			var $menuback = $('.js-header-menu-back');
			var flag = false;
			var scrollTopNow;
			// ハンバーガーメニュー
			$menu.on('click', function () {
				if (!flag) {
					scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;
					$menu.addClass(a);
					$menucontent.addClass(a);
					$('.container').css({
						position: 'fixed',
						width: '100%',
						top: -1 * scrollTopNow,
						left: 0
					});
					$('body').addClass(f);
					flag = true;
				} else {
					$menu.removeClass(a);
					$menucontent.removeClass(a);
					$('.container').css({
						position: 'static'
					});
					$('body').removeClass(f);

					$(window).scrollTop(scrollTopNow);
					$('.header-nav-content-li-in').removeClass(v);
					$('.header-nav-content-li_menu').stop().slideUp(400);
					flag = false;
				}
			});
			$menuback.on('click', function () {
				$menu.removeClass(a);
				$menucontent.removeClass(a);
				$('.container').css({
					position: 'static'
				});
				$('body').removeClass(f);

				$(window).scrollTop(scrollTopNow);
				$('.header-nav-content-li-in').removeClass(v);
				$('.header-nav-content-li_menu').stop().slideUp(400);
				flag = false;
			});
		},
		animation: function animation() {
			// 下からアニメーション
			if ($('.js-inview-bottom').length) {
				$('.js-inview-bottom').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
			// 左からアニメーション
			if ($('.js-inview-left').length) {
				$('.js-inview-left').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
			// 右からアニメーション
			if ($('.js-inview-right').length) {
				$('.js-inview-right').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
			// showroomアニメーション
			if ($('.showroom-box02').length) {
				$('.showroom-box02').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
		},
		slide: function slide() {
			if ($('.mod-slider-topics').length) {
				var dotsFlg = false;
				var variableWidthFlg = false;
				if ($('.mod-slider-topics').hasClass("_index")) {
					dotsFlg = true;
				}
				$('.mod-slider-topics').slick({
					autoplay: true,
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: true,
					dots: dotsFlg,
					arrows: true,
					prevArrow: '<a class="slick-prev opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
					nextArrow: '<a class="slick-next opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
					responsive: [{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							centerMode: true,
							centerPadding: '5%'
						}
					}]
				});
				$('.mod-slider-topics ._text').matchHeight();
				$('.mod-slider-topics ._title').matchHeight();
			}
			if ($('.mod-slider-brand').length) {
				$('.mod-slider-brand').slick({
					autoplay: true,
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					arrows: true,
					prevArrow: '<a class="slick-prev opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
					nextArrow: '<a class="slick-next opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
					dots: false,
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 1
						}
					}]
				});
			}
			if ($('.mod-slider-kurashi').length) {
				$('.mod-slider-kurashi').slick({
					autoplay: true,
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					arrows: true,
					prevArrow: '<a class="slick-prev opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
					nextArrow: '<a class="slick-next opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
					dots: false,
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 1
						}
					}]
				});
				$('.mod-slider-kurashi figure').matchHeight();
				$('.mod-slider-kurashi ._text').matchHeight();
				$('.mod-slider-kurashi .fw_bold').matchHeight();
				$('.mod-slider-kurashi ._title').matchHeight();
				$('.mod-slider-kurashi').on('afterChange', function (slick, currentSlide) {
					$('.mod-slider-kurashi figure').matchHeight();
					$('.mod-slider-kurashi ._text').matchHeight();
					$('.mod-slider-kurashi .fw_bold').matchHeight();
					$('.mod-slider-kurashi ._title').matchHeight();
				});
			}
			if ($('.mod-slider-casestudy').length) {
				$('.mod-slider-casestudy').slick({
					autoplay: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					arrows: true,
					prevArrow: '<a class="slick-prev opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
					nextArrow: '<a class="slick-next opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
					dots: true,
					responsive: [{
						breakpoint: 1024,
						settings: {
							dots: true
						}
					}]
				});
				$('.mod-slider-casestudy ._item').matchHeight();
			}
		},
		share: function share() {
			if ($('.mod-sns').length) {
				var pageUrl = document.URL;
				var shareUrl = "";
				var sharePagetitle = document.title;
				// facebook
				if ($('.mod-sns ._facebook').length) {
					shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
					$('.mod-sns ._facebook').attr('href', shareUrl);
				}
				// twitter
				if ($('.mod-sns ._twitter').length) {
					shareUrl = 'https://twitter.com/share?text=' + sharePagetitle + '&url=' + pageUrl;
					$('.mod-sns ._twitter').attr('href', shareUrl);
				}
				// line
				if ($('.mod-sns ._line').length) {
					shareUrl = 'https://social-plugins.line.me/lineit/share?url=' + pageUrl;
					$('.mod-sns ._line').attr('href', shareUrl);
				}
			}
		},
		columnNav: function columnNav() {
			if ($('.corporate-column-nav').length) {
				for (var i = 0; i < $('.corporate-column-nav a').length; i++) {
					if ($('.corporate-column-nav a').eq(i).attr('href') === location.pathname) {
						$('.corporate-column-nav a').eq(i).addClass(a);
					}
				}
				for (var _i = 0; _i < $('.corporate-column-nav ._head').length; _i++) {
					console.log($('.corporate-column-nav ._head a').eq(_i).attr('href'));
					if (location.pathname.indexOf($('.corporate-column-nav ._head a').eq(_i).attr('href')) != -1) {
						$('.corporate-column-nav ._head').eq(_i).addClass(a);
						$('.corporate-column-nav ._head').eq(_i).next('ul').removeClass('di_none');
					}
				}
			}
		},
		snsBtn: function snsBtn() {
			if ($('.js-sns-btn').length) {
				for (var i = 0; i < $('.js-sns-btn').length; i++) {
					var link = $('.js-sns-btn').eq(i).attr('href').replace('$URL$', location.href).replace('$title$', document.title);
					$('.js-sns-btn').eq(i).attr('href', link);
				}
				$('.js-sns-btn-clip').on('click', function () {
					var element = document.createElement('input');
					element.value = location.href;
					document.body.appendChild(element);
					element.select();
					document.execCommand('copy');
					document.body.removeChild(element);
				});
			}
		},
		pulldownJson: function pulldownJson() {
			// 汎用のプルダウンoption出力用
			// /kurashi/list.html
			// /case/building/
			// /case/material/
			// /coordinate/

			// クリアボタン
			$('.js-mod-form-clear').on('click', function () {
				$('input[type="text"]').val('');
				$('input[type="checkbox"]').prop('checked', false);
				$('input[type="radio"]').prop('checked', false);
				$('select').val('');
				// console.log("aaaaa");
			});
			// formアクション設定
			if ($('.js-form').length) {
				$('.js-form').attr('action', location.pathname + '#js-form');
			}
			// パラメータ格納関数
			var pArray = function pArray() {
				var urlParam = location.search.substring(1);
				var paramArray = [];
				if (urlParam) {
					var param = urlParam.split('&');
					for (var i = 0; i < param.length; i++) {
						var paramItem = param[i].split('=');
						paramArray[paramItem[0]] = paramItem[1];
					}
				}
				return paramArray;
			};
			if ($('.js-pulldown-theme').length) {
				var themePulldown = $('.js-pulldown-theme');
				var getJSONpulldowntheme = function getJSONpulldowntheme() {
					return $.getJSON('/ajax/news_tag/theme.json');
				};
				var thisTagName = themePulldown.attr('name');
				themePulldown.css('pointer-events', 'none');
				themePulldown.append($('<option>').html('選択してください').val(''));
				getJSONpulldowntheme().then(function (data) {
					// console.log(data,'getJSONpulldowntheme');
					for (var i = 0; i < data.rt_bn_tag.length; i++) {
						if (!(pArray()[thisTagName] === data.rt_bn_tag[i]._key)) {
							themePulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key));
						} else {
							themePulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key).prop('selected', true));
						}
					}
					themePulldown.css('pointer-events', 'auto');
				});
				themePulldown.change(function () {
					$('.js-form').submit();
				});
			}
			if ($('.js-pulldown-product').length) {
				var productPulldown = $('.js-pulldown-product');
				var getJSONpulldownproduct = function getJSONpulldownproduct() {
					return $.getJSON('/ajax/news_tag/product.json');
				};
				var _thisTagName = productPulldown.attr('name');
				productPulldown.css('pointer-events', 'none');
				productPulldown.append($('<option>').html('選択してください').val(''));
				getJSONpulldownproduct().then(function (data) {
					// console.log(data,'getJSONpulldownproduct');
					for (var i = 0; i < data.rt_bn_tag.length; i++) {
						if (!(pArray()[_thisTagName] === data.rt_bn_tag[i]._key)) {
							productPulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key));
						} else {
							productPulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key).prop('selected', true));
						}
					}
					productPulldown.css('pointer-events', 'auto');
				});
				productPulldown.change(function () {
					$('.js-form').submit();
				});
			}
			if ($('.js-pulldown-color').length) {
				var colorPulldown = $('.js-pulldown-color');
				var getJSONpulldowncolor = function getJSONpulldowncolor() {
					return $.getJSON('/ajax/news_tag/color.json');
				};
				var _thisTagName2 = colorPulldown.attr('name');
				colorPulldown.css('pointer-events', 'none');
				colorPulldown.append($('<option>').html('選択してください').val(''));
				getJSONpulldowncolor().then(function (data) {
					// console.log(data,'getJSONpulldowncolor');
					for (var i = 0; i < data.rt_bn_tag.length; i++) {
						if (!(pArray()[_thisTagName2] === data.rt_bn_tag[i]._key)) {
							colorPulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key));
						} else {
							colorPulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key).prop('selected', true));
						}
					}
					colorPulldown.css('pointer-events', 'auto');
				});
				colorPulldown.change(function () {
					$('.js-form').submit();
				});
			}
			if ($('.js-pulldown-roomtype').length) {
				var roomtypePulldown = $('.js-pulldown-roomtype');
				var getJSONpulldownroomtype = function getJSONpulldownroomtype() {
					return $.getJSON('/ajax/news_tag/room_type.json');
				};
				var _thisTagName3 = roomtypePulldown.attr('name');
				roomtypePulldown.css('pointer-events', 'none');
				roomtypePulldown.append($('<option>').html('選択してください').val(''));
				getJSONpulldownroomtype().then(function (data) {
					// console.log(data,'getJSONpulldownroomtype');
					for (var i = 0; i < data.rt_bn_tag.length; i++) {
						if (!(pArray()[_thisTagName3] === data.rt_bn_tag[i]._key)) {
							roomtypePulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key));
						} else {
							roomtypePulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key).prop('selected', true));
						}
					}
					roomtypePulldown.css('pointer-events', 'auto');
				});
				roomtypePulldown.change(function () {
					$('.js-form').submit();
				});
			}
			if ($('.js-pulldown-constructioncompany').length) {
				var constructioncompanyPulldown = $('.js-pulldown-constructioncompany');
				var getJSONpulldownconstructioncompany = function getJSONpulldownconstructioncompany() {
					return $.getJSON('/ajax/news_tag/construction_company.json');
				};
				var _thisTagName4 = constructioncompanyPulldown.attr('name');
				constructioncompanyPulldown.css('pointer-events', 'none');
				constructioncompanyPulldown.append($('<option>').html('選択してください').val(''));
				getJSONpulldownconstructioncompany().then(function (data) {
					// console.log(data,'getJSONpulldownconstructioncompany');
					for (var i = 0; i < data.rt_bn_tag.length; i++) {
						if (!(pArray()[_thisTagName4] === data.rt_bn_tag[i]._key)) {
							constructioncompanyPulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key));
						} else {
							constructioncompanyPulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key).prop('selected', true));
						}
					}
					constructioncompanyPulldown.css('pointer-events', 'auto');
				});
				constructioncompanyPulldown.change(function () {
					$('.js-form').submit();
				});
			}
			if ($('.js-pulldown-series').length) {
				var seriesPulldown = $('.js-pulldown-series');
				var getJSONpulldownseries = function getJSONpulldownseries() {
					return $.getJSON('/ajax/news_tag/series.json');
				};
				var _thisTagName5 = seriesPulldown.attr('name');
				seriesPulldown.css('pointer-events', 'none');
				seriesPulldown.append($('<option>').html('選択してください').val(''));
				getJSONpulldownseries().then(function (data) {
					// console.log(data,'getJSONpulldownseries');
					for (var i = 0; i < data.rt_bn_tag.length; i++) {
						if (!(pArray()[_thisTagName5] === data.rt_bn_tag[i]._key)) {
							seriesPulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key));
						} else {
							seriesPulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key).prop('selected', true));
						}
					}
					seriesPulldown.css('pointer-events', 'auto');
				});
				seriesPulldown.change(function () {
					$('.js-form').submit();
				});
			}
			if ($('.js-pulldown-taste').length) {
				var tastePulldown = $('.js-pulldown-taste');
				var getJSONpulldowntaste = function getJSONpulldowntaste() {
					return $.getJSON('/ajax/news_tag/taste.json');
				};
				var _thisTagName6 = tastePulldown.attr('name');
				tastePulldown.css('pointer-events', 'none');
				tastePulldown.append($('<option>').html('選択してください').val(''));
				getJSONpulldowntaste().then(function (data) {
					// console.log(data,'getJSONpulldowntaste');
					for (var i = 0; i < data.rt_bn_tag.length; i++) {
						if (!(pArray()[_thisTagName6] === data.rt_bn_tag[i]._key)) {
							tastePulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key));
						} else {
							tastePulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key).prop('selected', true));
						}
					}
					tastePulldown.css('pointer-events', 'auto');
				});
				tastePulldown.change(function () {
					$('.js-form').submit();
				});
			}
			if ($('.js-pulldown-color_tone').length) {
				var color_tonePulldown = $('.js-pulldown-color_tone');
				var getJSONpulldowncolor_tone = function getJSONpulldowncolor_tone() {
					return $.getJSON('/ajax/news_tag/color_tone.json');
				};
				var _thisTagName7 = color_tonePulldown.attr('name');
				color_tonePulldown.css('pointer-events', 'none');
				color_tonePulldown.append($('<option>').html('選択してください').val(''));
				getJSONpulldowncolor_tone().then(function (data) {
					// console.log(data,'getJSONpulldowncolor_tone');
					for (var i = 0; i < data.rt_bn_tag.length; i++) {
						if (!(pArray()[_thisTagName7] === data.rt_bn_tag[i]._key)) {
							color_tonePulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key));
						} else {
							color_tonePulldown.append($('<option>').html(data.rt_bn_tag[i].cf_nt_name_d).val(data.rt_bn_tag[i]._key).prop('selected', true));
						}
					}
					color_tonePulldown.css('pointer-events', 'auto');
				});
				color_tonePulldown.change(function () {
					$('.js-form').submit();
				});
			}
		},
		detailJson: function detailJson() {
			// 汎用の関連製品出力用
			// /news/$年$/detail/$記事ID$.html
			// /case/building/detail/$ID$.html
			// /case/material/detail/$ID$.html
			// /coordinate/detail/$ID$.html

			if ($('.js-relationproducts').length) {
				var getJSONrelationproducts = function getJSONrelationproducts(id) {
					return $.getJSON('/ajax/product/detail/' + id + '.json');
				};
				// 一件もない場合は要素ごと非表示
				if (!$('.rt_cf_n_product_id').length) {
					$('.js-relationproductsWrap').addClass('di_none');
				}
				var itemArray = [];
				var ItemList = new Promise(function (resolve) {
					var items = void 0;
					var count = 0;
					for (var i = 0; i < $('.rt_cf_n_product_id').length; i++) {
						getJSONrelationproducts($('.rt_cf_n_product_id').eq(i).text()).then(function (data) {
							var Html = '';
							// console.log(data.rt_bn_product_detail[0],'data');
							Html += '<li class="pure-u-1-3 pure-u-lg-1-2 pure-u-md-1-1 space-u-40-child">' + '<a href="' + data.rt_bn_product_detail[0].rt_detail_href.href + '" class="di_block opacity">' + '<figure><img src="' + data.rt_bn_product_detail[0].rt_cf_p_img.src + '" class="width-u-100" alt="' + data.rt_bn_product_detail[0].rt_cf_p_product_name.content[0] + '"></figure>' + '<p class="fs_20 fs_md_16 fw_bold mt10" data-mh="_text">' + data.rt_bn_product_detail[0].rt_cf_p_product_name.content[0] + '</p>' + '</a></li>';
							items = {
								itemsrc: Html,
								order: data.rt_bn_product_detail[0].cf_p_order
							};
							itemArray.push(items);
							count++;
							if (count === $('.rt_cf_n_product_id').length) {
								return resolve(itemArray);
							}
						});
					}
				});
				Promise.all([ItemList]).then(function () {
					// 昇順ソート
					itemArray.sort(function (itemA, itemB) {
						if (itemA.order < itemB.order) return -1;
						if (itemA.order > itemB.order) return 1;
						return 0;
					});
					// 描画
					// console.log(itemArray);
					for (var i = 0; i < itemArray.length; i++) {
						$('.js-relationproducts').append(itemArray[i].itemsrc);
					}
					$('._text').matchHeight();
				});
			}
		},
		tabSwitch: function tabSwitch() {
			var $tab = $('.js-tab');
			var $content = $('.js-tab-content');
			if ($('.js-tab').length) {
				var locHash = location.hash;
				if (locHash.length > 0) {
					var href = locHash.split('#')[1];

					$tab.each(function (idx, ele) {
						$(ele).removeClass(a);
						var dataSwitch = $(ele).attr('data-target');

						if (dataSwitch.match(href)) {
							$(ele).addClass(a);
						}
					});

					$content.each(function (idx, ele) {
						$(ele).removeClass(a).removeClass(v);
						var dataTarget = $(ele).attr('data-target');

						if (dataTarget.match(href)) {
							$(ele).addClass(a);
							setTimeout(function () {
								$(ele).addClass(v);
							}, '200');
						}
					});
				}

				$tab.on('click', function (e) {
					$(e.currentTarget).addClass(a);
					$tab.each(function (idx, ele) {
						$(ele).removeClass(a);
					});
					$content.each(function (idx, ele) {
						$(ele).removeClass(a).removeClass(v);
					});

					var $switch = $('[data-target=' + $(e.currentTarget).attr('data-target') + ']');
					$switch.addClass(a);
					setTimeout(function () {
						$switch.addClass(v);
					}, '200');
				});
			}
		},
		libraryListJson: function libraryListJson() {
			var getJSONlibraryListJp = function getJSONlibraryListJp(tag, year) {
				return $.getJSON('/ajax/ir/jp/' + tag + '/' + year + '.json');
			};
			var getJSONlibraryListEn = function getJSONlibraryListEn(tag, year) {
				return $.getJSON('/ajax/ir/en/' + tag + '/' + year + '.json');
			};
			if ($('.js-libraryList').length) {
				var tag = 'ir_' + location.pathname.split('/')[4].replace('.html', '');
				var latest = $('.rt_latest_year').text();
				var earliest = $('.rt_latest_year').text() - 5; // 6年分格納
				var itemArray = [];
				var ItemList = new Promise(function (resolve) {
					var items = void 0;
					var count = 0;
					for (var i = latest; i >= earliest; i--) {
						if (!(location.pathname.split('/')[1] === 'english')) {
							getJSONlibraryListJp(tag, i).then(function (data) {
								// console.log(data.rt_bn_news_list,'data');
								var navHtml = '';
								var _datatime = 0;
								var contentHtml = '';
								if (!(data.rt_bn_news_list.length == 0)) {
									// ナビ部分
									navHtml = '<li><p><a href="#' + data.rt_bn_news_list[0].rt_cf_n_year.content + '" rel="scroll">' + data.rt_bn_news_list[0].rt_cf_n_year.content + '年11月期<svg class="_icon"><use xlink:href="/common/svg/sprite.svg#arrow_bottom2" /></svg></a></p></li>';
									// ソート用年
									_datatime = data.rt_bn_news_list[0].rt_cf_n_year.content;
									// コンテンツ部分
									contentHtml = '<section id="' + data.rt_bn_news_list[0].rt_cf_n_year.content + '" class="mod-spacer">' + '<h3 class="mod-head03">' + data.rt_bn_news_list[0].rt_cf_n_year.content + '年11月期</h3>' + '<div class="p20 color-bg_gray3 mt40">' + '<ul class="pure-g space-u-10">';
									for (var l = 0; l < data.rt_bn_news_list.length; l++) {
										contentHtml += '<li class="pure-u-1-1 pure-u-lg-1-1 space-u-10-child">' + '<a href="' + data.rt_bn_news_list[l].rt_cf_n_href.href + '" class="mod-link01" target="_blank"><span class="">' + data.rt_bn_news_list[l].rt_cf_n_title.content[0] + '</span><svg class="ml10"><use xlink:href="/common/svg/sprite.svg#blank" /></svg></a>' + '</li>';
									}
									contentHtml += '</ul></div></section>';
								}
								items = {
									navsrc: navHtml,
									datatime: _datatime,
									contentsrc: contentHtml
								};
								itemArray.push(items);
								count++;
								// console.log(count);
								if (count == 6) {
									// 6年分格納
									return resolve(itemArray);
								}
							});
						} else {
							getJSONlibraryListEn(tag, i).then(function (data) {
								// console.log(data.rt_bn_news_list,'data');
								var navHtml = '';
								var _datatime = 0;
								var contentHtml = '';
								if (!(data.rt_bn_news_list.length == 0)) {
									// ナビ部分
									navHtml = '<li><p><a href="#' + data.rt_bn_news_list[0].rt_cf_n_year.content + '" rel="scroll">FY Ended Nov. ' + data.rt_bn_news_list[0].rt_cf_n_year.content + '<svg class="_icon"><use xlink:href="/common/svg/sprite.svg#arrow_bottom2" /></svg></a></p></li>';
									// ソート用年
									_datatime = data.rt_bn_news_list[0].rt_cf_n_year.content;
									// コンテンツ部分
									contentHtml = '<section id="' + data.rt_bn_news_list[0].rt_cf_n_year.content + '" class="mod-spacer">' + '<h3 class="mod-head03">FY Ended Nov. ' + data.rt_bn_news_list[0].rt_cf_n_year.content + '</h3>' + '<div class="p20 color-bg_gray3 mt40">' + '<ul class="pure-g space-u-10">';
									for (var l = 0; l < data.rt_bn_news_list.length; l++) {
										contentHtml += '<li class="pure-u-1-1 pure-u-lg-1-1 space-u-10-child">' + '<a href="' + data.rt_bn_news_list[l].rt_cf_n_href.href + '" class="mod-link01" target="_blank"><span class="">' + data.rt_bn_news_list[l].rt_cf_n_title.content[0] + '</span><svg class="ml10"><use xlink:href="/common/svg/sprite.svg#blank" /></svg></a>' + '</li>';
									}
									contentHtml += '</ul></div></section>';
								}
								items = {
									navsrc: navHtml,
									datatime: _datatime,
									contentsrc: contentHtml
								};
								itemArray.push(items);
								count++;
								// console.log(count);
								if (count == 6) {
									// 6年分格納
									return resolve(itemArray);
								}
							});
						}
					}
				});
				Promise.all([ItemList]).then(function () {
					// 降順ソート
					// console.log(itemArray,'itemArray');
					itemArray.sort(function (itemA, itemB) {
						if (itemA.datatime > itemB.datatime) return -1;
						if (itemA.datatime < itemB.datatime) return 1;
						return 0;
					});
					// 描画
					// console.log(itemArray,'itemArraysort');
					// console.log(itemArray.length,'itemArraysort');
					for (var i = 0; i < itemArray.length; i++) {
						if (!(itemArray[0].datatime == latest && itemArray[i].datatime == earliest)) {
							$('.js-libraryList').append(itemArray[i].navsrc);
							$('.js-libraryList-contents').append(itemArray[i].contentsrc);
						}
					}

					$(document).on('click', 'a[rel="scroll"]', function (event) {
						var speed = 1200;
						if (/#/.test(event.currentTarget.href)) {
							scrollToObject(event.currentTarget.href, speed);
						}
						return false;
					});
					function scrollToObject(_self, _speed) {
						var hash = '#' + _self.split('#')[1];
						var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

						if (hash !== '#pagetop') {
							if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
								pos -= 60;
							} else {
								pos -= 90;
							}
						}
						$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
					}
				});
			}
		},
		fileSizeEx: function fileSizeEx() {
			if ($('.js-fileSize').length) {
				$('.js-fileSize').each(function () {
					$(this).text('（' + bytesToSize($(this).text()) + '）');
				});
			}
			function bytesToSize(bytes) {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			}
		},
		megaMenu: function megaMenu() {
			if (document.querySelectorAll('.header').length) {
				// グロナビカレント
				document.querySelectorAll('.js-header-current').forEach(function (item1) {
					console.log(item1.dataset.current, location.pathname.split('/')[1]);
					if (item1.dataset.current == location.pathname.split('/')[1]) {
						item1.classList.add('is-current');
					}
				});
				// 言語ホバーメニュー
				if (location.pathname.split('/')[1] == 'history') {
					var setHref = '';
					var setHrefSp = '';
					if (location.pathname.split('/')[2] == 'en') {
						setHref = location.pathname.replace('/en/', '/jp/');
						setHrefSp = location.pathname.replace('/en/', '/jp/');
					} else {
						setHref = location.pathname.replace('/jp/', '/en/');
						setHrefSp = location.pathname.replace('/jp/', '/en/');
					}
					document.querySelector('.header-nav-sub-lang-a').setAttribute('href', setHref);
					document.querySelector('.header-nav-sp-lang-a').querySelector('a').setAttribute('href', setHrefSp);

					document.querySelector('.header-nav-sub-lang-a').classList.remove('di_none');
					document.querySelector('.header-nav-sp-lang-a').classList.remove('di_none');

					document.querySelector('.header-nav-sub-lang-hovWrap').classList.add('di_none');
					document.querySelector('.header-nav-sp-lang-hovWrap').classList.add('di_none');
				}
				if (location.pathname.split('/')[2] == 'ir') {
					var _setHref = '';
					var _setHrefSp = '';
					if (location.pathname.split('/')[1] == 'en') {
						_setHref = location.pathname.replace('/en/', '/jp/');
						_setHrefSp = location.pathname.replace('/en/', '/jp/');
					} else {
						_setHref = location.pathname.replace('/jp/', '/en/');
						_setHrefSp = location.pathname.replace('/jp/', '/en/');
					}
					document.querySelector('.header-nav-sub-lang-a').setAttribute('href', _setHref);
					document.querySelector('.header-nav-sp-lang-a').querySelector('a').setAttribute('href', _setHrefSp);

					document.querySelector('.header-nav-sub-lang-a').classList.remove('di_none');
					document.querySelector('.header-nav-sp-lang-a').classList.remove('di_none');

					document.querySelector('.header-nav-sub-lang-hovWrap').classList.add('di_none');
					document.querySelector('.header-nav-sp-lang-hovWrap').classList.add('di_none');
				}
				if (document.querySelectorAll('.header-nav-sub-lang-hov-button').length) {
					document.querySelector('.header-nav-sub-lang-hov-button').addEventListener("keydown", function (e) {
						// Enterキーでメガメニューの開閉
						if (e.keyCode === 13) {
							if (document.querySelector('.header-nav-sub-lang-hov').classList.contains(a)) {
								document.querySelector('.header-nav-sub-lang-hov').classList.remove(a);
							} else {
								document.querySelector('.header-nav-sub-lang-hov').classList.add(a);
							}
						}
						// ESCキーでメガメニューを閉じる
						if (e.keyCode === 27) {
							if (document.querySelector('.header-nav-sub-lang-hov').classList.contains(a)) {
								document.querySelector('.header-nav-sub-lang-hov').classList.remove(a);
							}
						}
						// メガメニューを開いた状態で、一つ前の項目に移動した場合、メガメニューを閉じる
						if (e.shiftKey) {
							if (e.keyCode === 9) {
								document.querySelector('.header-nav-sub-lang-hov').classList.remove(a);
							}
						}
					});
					document.querySelectorAll('.header-nav-sub-lang-hov a').forEach(function (aitem, index, array) {
						aitem.addEventListener("keydown", function (e) {
							// ESCキーでメガメニューを閉じる
							if (e.keyCode === 27) {
								if (document.querySelector('.header-nav-sub-lang-hov').classList.contains(a)) {
									document.querySelector('.header-nav-sub-lang-hov').classList.remove(a);
								}
							}
						});
						if (index === array.length - 1) {
							// メガメニューの最後の項目にフォーカス状態で、Tabを押したとき、メガメニューを閉じる
							aitem.addEventListener("keydown", function (e) {
								if (e.keyCode === 9) {
									if (document.querySelector('.header-nav-sub-lang-hov').classList.contains(a)) {
										document.querySelector('.header-nav-sub-lang-hov').classList.remove(a);
									}
								}
							});
						}
					});
				}
			}
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.modal();
			_this.headerMenu();
			_this.headerMenu();
			_this.animation();
			_this.slide();
			_this.share();
			_this.columnNav();
			_this.pulldownJson();
			_this.detailJson();
			_this.tabSwitch();
			_this.libraryListJson();
			_this.fileSizeEx();
			_this.megaMenu();
			svg4everybody();
		}
	};

	$(function () {
		return FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript();
	});
})(window.jQuery);
$(window).on('load', function () {
	var slideMain = function slideMain() {
		var cssua = window.cssua || null;
		if ($('.mod-slider-main').length) {
			for (var i = 0; i < $('.mod-slider-main-item-bg').length; i++) {
				var img = $('.mod-slider-main-item-bg').eq(i).data('img');
				var navHeight = void 0;
				$('.mod-slider-main-item-bg').eq(i).css('background-image', 'url(' + img + ')');
				navHeight = $('.header').outerHeight(true);
				$('.mod-slider-main-item-bg').eq(i).height($(window).height() - navHeight);
			}
			$('.mod-slider-main').slick({
				autoplay: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				arrows: true,
				prevArrow: '<a class="slick-prev opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				dots: true,
				autoplaySpeed: 4000,
				speed: 1000
			});
		}
		if ($('.mod-slider-main-fade').length) {
			for (var _i2 = 0; _i2 < $('.mod-slider-main-fade-item-bg').length; _i2++) {
				var _img = $('.mod-slider-main-fade-item-bg').eq(_i2).data('img');
				var _navHeight = void 0;
				$('.mod-slider-main-fade-item-bg').eq(_i2).css('background-image', 'url(' + _img + ')');
				_navHeight = $('.header').outerHeight(true);
				$('.mod-slider-main-fade-item-bg').eq(_i2).height($(window).height() - _navHeight);
			}
			$('.mod-slider-main-fade').slick({
				autoplay: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				arrows: true,
				prevArrow: '<a class="slick-prev opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				dots: true,
				fade: true,
				autoplaySpeed: 4000,
				speed: 1000
			});
		}
	};
	slideMain();
});